import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta.js';
import { Faq, Subpage } from '../site/Subpage.jsx';
import { useSite } from '../site/SiteShell.jsx';
import { RuntimeNotice } from '../site/RuntimeNotice.jsx';

import { FAQ_ITEMS } from '../data/faq.js';

const Side = () => {
    const { openStudio, openAccount } = useSite();
    return (
        <div className="side pg-head gl pg-enter" style={{ '--i': 0, marginBottom: 0 }}>
            <h1 className="h-page">Questions, answered plainly.</h1>
            <p className="lead">Open only what you need. Nothing here has to be read in order.</p>
            <div className="pg-actions">
                <button type="button" className="btn primary" onClick={openStudio}>Open the studio</button>
                <button type="button" className="btn glass" onClick={() => openAccount('signup')}>Create a free account</button>
            </div>
        </div>
    );
};

export const FAQPage = () => {
    useRouteMeta('/faq');
    return (
        <Subpage>
            <div className="pg-wrap pg-faqlay" style={{ paddingTop: 40 }}>
                <RuntimeNotice/>
                <Side/>
                <section aria-label="Frequently asked questions"><Faq items={FAQ_ITEMS}/></section>
            </div>
        </Subpage>
    );
};
